import { useQuery } from "@tanstack/react-query";
import { useDataImportApiClient } from "../../hooks";

// Statuses whose pipeline is still moving
const ACTIVE_STATUSES = ["READY_FOR_PROCESSING", "IMPORTING"];

const REFRESH_INTERVAL_MS = 10_000;

/** A data import with its steps, refreshed while its pipeline runs. */
export const useDataImportDetail = (dataImportId: string | null) => {
    const apiClient = useDataImportApiClient();
    return useQuery({
        queryKey: ["dataImportDetail", dataImportId],
        queryFn: () => apiClient.dataImportRetrieve({ id: dataImportId }),
        enabled: !!dataImportId,
        refetchOnWindowFocus: false,
        refetchInterval: (data) =>
            data && ACTIVE_STATUSES.includes(data.status)
                ? REFRESH_INTERVAL_MS
                : false,
    });
};
